import { all, takeEvery, put, call, fork } from "redux-saga/effects";
// import CatTreeHelper from '@iso/lib/api/catTreeHelper';
import CatHelper from "@iso/lib/api/catHelper";
import { notification } from '@iso/components';

import actions from "./actions";
//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
function* CatReadRequest() {
  yield takeEvery(actions.CAT_TREE_LIST, function* ({ payload }) {
    try {
      payload.flag = "categoryTree";
      console.log("payload", payload);

      const searchResult = yield call(CatHelper.read, payload);
      console.log("searchResult", searchResult);
      if (searchResult.status) {
        yield put(
          actions.catTreeListSuccess(
            searchResult.exportresult,
            searchResult.result,
            searchResult.status,
            searchResult.totalRecordCount
          )
        );
      } else {
        notification("error", searchResult.message);
        yield put(
          actions.catTreeListSuccess([],[],0,0)
        );
      }
    } catch (error) {}
  });
}
/**
 * For adding new Leaf Category
 */
// function* CatLeafAddRequest() {
//   yield takeEvery(actions.CAT_LEAF_ADD, function* ({ payload }) {
//     console.log('payload', payload)
//     try {
//       const result = yield call(CatHelper.leafAdd, payload.dataObj);
//       console.log("result", result);
//       if (result.status == 0) {
//         notification("error", result.message);
//       } else {
//         notification("success", result.message);
//         payload.history.push("/dashboard/categorytree");
//       }
//     } catch (error) {}
//   });
// }
/*****fetch user record  *************/

/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([
    //  takeEvery(actions.USER_LIST, searchRequest)
    fork(CatReadRequest),
    // fork(CatLeafAddRequest),
  ]);
}
